import {
    AlertsApiFactory,
    V1Alert,
    V1AlertType,
    V1AlertStatus,
    V1ToiletType,
} from "@vacancorp/enterprise-for-client.vacanservice.com";
import { Alert, AlertType, AlertStatus, ToiletType } from "@/models";
import { api, ApiResponse, ListResponse, createApiError } from "./base";
import axios, { AxiosError, AxiosResponse, AxiosInstance } from "axios";
import http from "@/api/http";
function convertAlertType(rawAlertType?: V1AlertType): AlertType {
    switch (rawAlertType) {
        case V1AlertType.UNKNOWNALERTTYPE:
            return AlertType.UNKNOWN_ALERT_TYPE;
        case V1AlertType.LONGSTAYALERT:
            return AlertType.LONG_STAY_ALERT;
        case V1AlertType.LOWBATTERYALERT:
            return AlertType.LOW_BATTERY_ALERT;
        case V1AlertType.FAILUREALERT:
            return AlertType.FAILURE_ALERT;
        default:
            return AlertType.UNKNOWN_ALERT_TYPE;
    }
}

function convertToiletType(rawToiletType?: V1ToiletType): ToiletType {
    switch (rawToiletType) {
        case V1ToiletType.UNKNOWNTOILETTYPE:
            return ToiletType.UNKNOWN_TOILET_TYPE;
        case V1ToiletType.FORMAN:
            return ToiletType.FOR_MAN;
        case V1ToiletType.FORWOMAN:
            return ToiletType.FOR_WOMAN;
        case V1ToiletType.UNISEX:
            return ToiletType.UNISEX;
        case V1ToiletType.MULTIPURPOSE:
            return ToiletType.MULTI_PURPOSE;
        default:
            return ToiletType.UNKNOWN_TOILET_TYPE;
    }
}

function convertAlertStatus(rawAlertStatus?: V1AlertStatus): AlertStatus {
    switch (rawAlertStatus) {
        case V1AlertStatus.UNKNOWNALERTSTATUS:
            return AlertStatus.UNKNOWN_ALERT_STATUS;
        case V1AlertStatus.ALERT:
            return AlertStatus.ALERT;
        case V1AlertStatus.RESOLVED:
            return AlertStatus.RESOLVED;
        default:
            return AlertStatus.UNKNOWN_ALERT_STATUS;
    }
}

function createAlerts(rawAlerts?: V1Alert[]): Alert[] {
    if (!rawAlerts) return [] as Alert[];

    return rawAlerts.map(
        // TODO: enterprise-for-client 撲滅したらこの & 消せる。
        (a: V1Alert & { floorPlanUrl?: string }): Alert => {
            return new Alert({
                alertType: a.alertType,
                status: a.status,
                floor: a.floor,
                kind: a.kind,
                areaName: a.areaName,
                name: a.name,
                time: a.time,
                floorPlanUrl: a.floorPlanUrl,
            });
        },
    );
}

export const NewAlertsApiFunc = () => {
    const webAdapter = AlertsApiFactory(undefined, api.defaults.baseURL, api);

    return {
        listAlerts: async (
            companyId: string,
            filter?: string,
            page?: number,
        ): Promise<ApiResponse<ListResponse<Alert>>> => {
            let data, currentPage, totalPage, err;

            try {
                const res = await webAdapter.listAlerts(companyId, filter, page);
                data = createAlerts(res.data.alerts);
                currentPage = res.data.currentPage;
                totalPage = res.data.totalPage;
            } catch (e) {
                data = [] as Alert[];
                err = createApiError(e);
            }

            return {
                data: {
                    list: data,
                    currentPage: currentPage || 1,
                    totalPage: totalPage || 1,
                },
                err,
            };
        },
    };
};

export const NewLongStayAlertsApiFunc = () => {
    return {
        listAlerts: async (
            companyId: string,
            filter?: string,
            page?: number,
        ): Promise<ApiResponse<ListResponse<Alert>>> => {
            let data, currentPage, totalPage, err;
            try {
                const res = await http
                    .get<any>(`/v1/companies/${companyId}/alerts/logs/long_stay`, { params: { filter, page } })
                    .then((response: any) => {
                        return response.status === 200 ? response.data : Promise.reject(400);
                    })
                    .catch((error: AxiosError) => {
                        return Promise.reject(
                            error.response ? error.response.data.errors : { message: "connection error", name: "" },
                        );
                    });
                data = createAlerts(res.alerts);
                currentPage = res.currentPage;
                totalPage = res.totalPage;
            } catch (e) {
                data = [] as Alert[];
                err = createApiError(e);
            }
            return {
                data: {
                    list: data,
                    currentPage: currentPage || 1,
                    totalPage: totalPage || 1,
                },
                err,
            };
        },
        listActiveAlerts: async (
          companyId: string,
          filter?: string,
          page?: number,
        ): Promise<ApiResponse<ListResponse<Alert>>> => {
            let data, currentPage, totalPage, err;
            try {
                const res = await http
                  .get<any>(`/v1/companies/${companyId}/alerts/active/long_stay`, { params: { filter, page } })
                  .then((response: any) => {
                      return response.status === 200 ? response.data : Promise.reject(400);
                  })
                  .catch((error: AxiosError) => {
                      return Promise.reject(
                        error.response ? error.response.data.errors : { message: "connection error", name: "" },
                      );
                  });
                data = createAlerts(res.alerts);
                currentPage = res.currentPage;
                totalPage = res.totalPage;
            } catch (e) {
                data = [] as Alert[];
                err = createApiError(e);
            }
            return {
                data: {
                    list: data,
                    currentPage: currentPage || 1,
                    totalPage: totalPage || 1,
                },
                err,
            };
        },
    };
};
